import { useEffect, useRef } from "react";
import { useSearchResultList } from "../../../../common/components/search/SearchResultList.hooks.ts";

export function useAddRelationSearch() {
    const searchInputRef = useRef<HTMLTextAreaElement>();

    const { isLoading, entitySearchSuggestions, isEntitySpecificSearch, fetchSuggestions, initSuggestions, onShowMoreForEntityTypeClick } =
        useSearchResultList(false);

    useEffect(() => {
        searchInputRef.current?.focus();
        initSuggestions();
        // eslint-disable-next-line
    }, []);

    return {
        fetchSuggestions,
        isLoading,
        suggestions: entitySearchSuggestions,
        searchInputRef,
        onShowMoreForEntityTypeClick,
        isEntitySpecificSearch,
    };
}
